import { convertToDropdownOption } from '@/utils/object';

export const ALL_ITEMS = 'ALL';
export const ITEMS_PER_PAGE = [15, 25, 50, 100] as const;
export const ITEMS_PER_PAGE_OPTIONS = ITEMS_PER_PAGE.map(value => convertToDropdownOption(`${value}`, value));
